import { render, staticRenderFns } from "./checkboxField.vue?vue&type=template&id=065a529c&"
import script from "./checkboxField.vue?vue&type=script&lang=js&"
export * from "./checkboxField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports